@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

.root {
    --header-to-slides-margin: var(--spacer-40);
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.header {
    composes: container from "../../styles/composable/layout.module.css";
    margin-bottom: var(--header-to-slides-margin);
    padding-right: var(--spacer-120);
}

.inner {
    position: relative;
}

.carousel {
    width: 100%;
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.noScrollDesktop {
    @media ($above-tablet) {
        ul {
            display: flex;
            justify-content: center;
        }
    }
}

.noScrollTablet {
    @media ($above-mobile) {
        ul {
            display: flex;
            justify-content: center;
        }
    }
}

.noScrollMobile {
    ul {
        display: flex;
        justify-content: center;
    }
}

// slides-visible desktop/tablet/mobile values are set in the TSX file
.listItem {
    --slides-visible: var(--slides-visible-desktop);
    --gutters: calc(var(--slides-visible) - 1);
    --gutter-width: var(--spacer-32);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--slides-visible));

    width: var(--width);
    aspect-ratio: 596/460;
    max-height: 100%;
    overflow-y: hidden;
    margin-right: var(--gutter-width);
    vertical-align: top;

    &.singleListItem,
    &:last-child {
        margin-right: 0;
    }

    @media ($below-tablet) {
        --slides-visible: var(--slides-visible-tablet);
    }

    @media ($below-mobile) {
        --slides-visible: var(--slides-visible-mobile);
    }
}

.carouselNav {
    position: absolute;
    top: 0;
    right: var(--labui-container-margin);
    translate: 0 calc(-100% - var(--header-to-slides-margin));
    gap: var(--spacer-24);

    & button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: var(--spacer-32);
        height: var(--spacer-32);
        box-shadow: inset 0 0 0 1px var(--color-contrast);

        svg {
            width: var(--spacer-16);
            height: var(--spacer-16);
        }
    }

    @media ($below-mobile) {
        display: none;
    }
}

.slide {
    composes: dark from "../../styles/theming.module.css";
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    gap: var(--spacer-24);
    height: 100%;
    padding: var(--spacer-32);
    text-align: left;
    text-wrap: wrap;
    z-index: 0;

    > svg {
        display: none;
    }
}

.mediaSlide {
    composes: slide;

    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            180deg,
            rgb(var(--black-base) / 0%) 45%,
            rgb(var(--black-base) / 75%) 80%
        );
    }
}

.gradientSlide {
    composes: slide;
    background: var(--xcient-gradient);
}

.mediaWrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.videoControls {
    bottom: unset;
    top: var(--spacer-24);
}

.richText {
    position: relative;
    z-index: 1;

    & :is(h1, h2, h3, h4, h5, h6) {
        font: var(--font-h-32);
    }
}

.fakeBorderless {
    @include borderless-button;

    z-index: 1;
}

.dots {
    margin-top: var(--spacer-24);

    @media ($above-mobile) {
        display: none;
    }
}
